export function bucketNameFromLocation(location: string) {
  const locationWithoutProtocol = location.substring(5);
  const fileNameStart = locationWithoutProtocol.indexOf('/');

  return locationWithoutProtocol.substring(0, fileNameStart);
}

export function fileNameFromLocation(location: string) {
  const locationWithoutProtocol = location.substring(5);
  const fileNameStart = locationWithoutProtocol.indexOf('/');

  return locationWithoutProtocol.substring(fileNameStart + 1);
}
